import { createContext, useContext } from 'react';

import { InfoKey } from '@/contexts/infoPanel/model/InfoKey.enum.ts';

type InfoPanelContextValue = {
  closePanel: () => void;
  currentInfoKey: InfoKey | null;
  isOpen: boolean;
  openPanel: (key: InfoKey) => void;
};

const InfoPanelContext = createContext<InfoPanelContextValue | null>(null);

export const InfoPanelContextProvider = InfoPanelContext.Provider;

export const useInfoPanel = (): InfoPanelContextValue => {
  const context = useContext(InfoPanelContext);

  if (!context) {
    throw new Error('useInfoPanel must be used within InfoPanelProvider');
  }

  return context;
};
